export default __webpack_public_path__ + "static/media/CorujaOptionModal.97c9a833.png";